import React, { Component } from 'react';
import WindowOptionButton from '../WindowOptionButton';
import GameQuery from '../../query/GameQuery';
import { formatRoute } from 'react-router-named-routes';
import { GAME } from '../../routes';
class WindowCloseButton extends Component {
	render() {
		const { history } = this.props;
		return (
			<GameQuery>
				{props => (
					<WindowOptionButton
						backgroundColor="#f21b35"
						color="#710000"
						textOnOver="x"
						onClick={() =>
							history.push(formatRoute(GAME, { gameID: props.game.id }))
						}
						{...this.props}
					/>
				)}
			</GameQuery>
		);
	}
}

export default WindowCloseButton;
